import { THREE, CSMShader } from '../../base/three-defs.js';


class ShaderManager {
  static shaderCode = {};
  static threejs = null;
};

export function SetThreeJS(threejs) {
  ShaderManager.threejs = threejs;
}

export async function loadShaders() {
  const loadText = async (url) => {
    const d = await fetch(url);
    return await d.text();
  };

  const globalShaders = [
    'header.glsl',
    'common.glsl',
    'oklab.glsl',
    'noise.glsl',
    'atmosphere/atmosphere-common.glsl',
    'sky.glsl',
  ];

  const globalShadersCode = [];
  for (let i = 0; i < globalShaders.length; ++i) {
    globalShadersCode.push(await loadText('shaders/' + globalShaders[i]));
  }

  const loadShader = async (url) => {
    const d = await fetch(url);
    let shaderCode = '';
    for (let i = 0; i < globalShadersCode.length; ++i) {
      shaderCode += globalShadersCode[i] + '\n';
    }
    return shaderCode + '\n' + await d.text();
  }

  ShaderManager.shaderCode['GRASS'] = {
    vsh: await loadShader('shaders/grass-lighting-model-vsh.glsl'),
    fsh: await loadShader('shaders/grass-lighting-model-fsh.glsl'),
  };

  ShaderManager.shaderCode['TERRAIN'] = {
    vsh: await loadShader('shaders/terrain-lighting-model-vsh.glsl'),
    fsh: await loadShader('shaders/terrain-lighting-model-fsh.glsl'),
  };

  ShaderManager.shaderCode['SKY'] = {
    vsh: await loadShader('shaders/sky-lighting-model-vsh.glsl'),
    fsh: await loadShader('shaders/sky-lighting-model-fsh.glsl'),
  };

  ShaderManager.shaderCode['SKY-DISPLAY'] = {
    vsh: await loadShader('shaders/sky-display-vsh.glsl'),
    fsh: await loadShader('shaders/sky-display-fsh.glsl'),
  };
}


export class ShaderMaterial extends THREE.ShaderMaterial {
  constructor(shaderType, parameters) {
    parameters.vertexShader = ShaderManager.shaderCode[shaderType].vsh;
    parameters.fragmentShader = ShaderManager.shaderCode[shaderType].fsh;

    super(parameters);
  }
};

export class GamePBRMaterial extends THREE.MeshStandardMaterial {

  #uniforms_ = {};
  #shader_ = null;

  constructor(shaderType, parameters) {
    super(parameters);

    this.#shader_ = null;
    this.#uniforms_ = {};

    ShaderManager.threejs.SetupMaterial(this);

    const previousCallback = this.onBeforeCompile;
    
    this.onBeforeCompile = (shader) => {
        shader.fragmentShader = ShaderManager.shaderCode[shaderType].fsh;
        shader.vertexShader = ShaderManager.shaderCode[shaderType].vsh;
        shader.uniforms.time = { value: 0.0 };
        shader.uniforms.playerPos = { value: new THREE.Vector3(0.0) };

        for (let k in this.#uniforms_) {
          shader.uniforms[k] = this.#uniforms_[k];
        }

        this.#shader_ = shader;

        previousCallback(shader);
    };

    this.customProgramCacheKey = () => {
      let uniformStr = '';
      for (let k in this.#uniforms_) {
        uniformStr += k + ':' + this.#uniforms_[k].value + ';';
      }
      return shaderType + uniformStr;
    }
  }

  // Mutates the existing uniform record when present so per-frame updates
  // do not allocate.
  setUniform_(name, value) {
    const u = this.#uniforms_[name];
    if (u !== undefined) {
      u.value = value;
      return;
    }
    this.#uniforms_[name] = { value: value };
    if (this.#shader_) {
      this.#shader_.uniforms[name] = this.#uniforms_[name];
    }
  }

  setFloat(name, value) { this.setUniform_(name, value); }
  setVec2(name, value) { this.setUniform_(name, value); }
  setVec3(name, value) { this.setUniform_(name, value); }
  setVec4(name, value) { this.setUniform_(name, value); }
  setMatrix(name, value) { this.setUniform_(name, value); }
  setTexture(name, value) { this.setUniform_(name, value); }
  setTextureArray(name, value) { this.setUniform_(name, value); }
}

export class GameMaterial extends THREE.MeshPhongMaterial {

  #uniforms_ = {};
  #shader_ = null;

  constructor(shaderType, parameters) {
    super(parameters);

    this.#shader_ = null;
    this.#uniforms_ = {};

    ShaderManager.threejs.SetupMaterial(this);

    const previousCallback = this.onBeforeCompile;

    this.onBeforeCompile = (shader) => {
        shader.fragmentShader = ShaderManager.shaderCode[shaderType].fsh;
        shader.vertexShader = ShaderManager.shaderCode[shaderType].vsh;
        shader.uniforms.time = { value: 0.0 };
        shader.uniforms.playerPos = { value: new THREE.Vector3(0.0) };

        for (let k in this.#uniforms_) {
          shader.uniforms[k] = this.#uniforms_[k];
        }

        this.#shader_ = shader;

        previousCallback(shader);
    };

    this.customProgramCacheKey = () => {
      let uniformStr = '';
      for (let k in this.#uniforms_) {
        uniformStr += k + ':' + this.#uniforms_[k].value + ';';
      }
      return shaderType + uniformStr;
    }
  }

  // Mutates the existing uniform record when present so per-frame updates
  // do not allocate.
  setUniform_(name, value) {
    const u = this.#uniforms_[name];
    if (u !== undefined) {
      u.value = value;
      return;
    }
    this.#uniforms_[name] = { value: value };
    if (this.#shader_) {
      this.#shader_.uniforms[name] = this.#uniforms_[name];
    }
  }

  setFloat(name, value) { this.setUniform_(name, value); }
  setVec2(name, value) { this.setUniform_(name, value); }
  setVec3(name, value) { this.setUniform_(name, value); }
  setVec4(name, value) { this.setUniform_(name, value); }
  setMatrix(name, value) { this.setUniform_(name, value); }
  setTexture(name, value) { this.setUniform_(name, value); }
  setTextureArray(name, value) { this.setUniform_(name, value); }
}


